import InvoicesApi from '@/services/shop/InvoicesApiV2'
import type { InvoiceInterface } from '@/models/shop/InvoiceV2.types'

export { InvoiceInterface }

export class InvoiceDTO implements InvoiceInterface {
  cart_id = ''
  number = ''
  arena_id = 0
  restoring_invoice_id = ''
  restoring_reason = ''
  arena_cash_register_id = ''
  payment_method_id = ''
  company_id = ''
  company_name = ''
  company_address = ''
  company_legal_name = ''
  company_tax_number = ''
  invoice_file_name = ''
  fiscalization_required = false
  fiscalization_data = {}
  seller_user_id = 0
  seller_user_username = ''
  seller_user_name = ''
  seller_user_address = ''
  seller_user_pidn = ''
  buyer_user_id = 0
  b2b_legal_name = ''
  b2b_address = ''
  b2b_tax_number = ''
  created_at = ''
  updated_at = ''
  id = ''
  total_gross_amount = ''
  manual_discount_amount = ''
}

export default class Invoice extends InvoiceDTO {
  static api = InvoicesApi

  constructor(DTO: InvoiceDTO) {
    super()
    Object.assign(this, DTO)
  }
}
